class HomeController {
    constructor(reactComponent, storeController) {
        this.reactComponent = reactComponent;
        this._storeController = storeController;
        //Bindings
        this.addBookmark = this.addBookmark.bind(this);
        this.removeBookmark = this.removeBookmark.bind(this);
        this.listAllBookmarks = this.listAllBookmarks.bind(this);
        this.saveSession = this.saveSession.bind(this);
        this.listAllSessions = this.listAllSessions.bind(this);
        this.processPickedFiles = this.processPickedFiles.bind(this);
        this.listMostUsedFiles = this.listMostUsedFiles.bind(this);
    }

    addBookmark(bookmarkName, bookmarkFilters) {
        let bookmarks = this._storeController.get('bookmarks');
        if (!bookmarks) {
            bookmarks = [];
        }
        let bookmark = {
            name: bookmarkName,
            filters: bookmarkFilters
        };

        let index = -1;
        for (let i = 0; i < bookmarks.length && index === -1; i++) {
            let aux = bookmarks[i].name;
            if (aux === bookmarkName) {
                index = i;
            }
        };
        // console.log(bookmark);
        if (index !== -1) {
            bookmarks = Object.assign([], bookmarks, { index: bookmark });
        } else {
            bookmarks = bookmarks.concat(bookmark);
        }

        this._storeController.set('bookmarks', bookmarks);
    }

    removeBookmark(bookmarkName) {
        let bookmarks = this.reactComponent.state.bookmarks;
        if (bookmarks) {
            bookmarks = bookmarks.filter(bookmark => bookmark.name !== bookmarkName);
            this._storeController.set('bookmarks', bookmarks);
            this.reactComponent.setState({ bookmarks });
        }
    }

    listAllBookmarks() {
        let bookmarks = this._storeController.get('bookmarks');
        if (!bookmarks) {
            bookmarks = [];
        }
        //console.log(bookmarks);
        this.reactComponent.setState({ bookmarks });
    }

    saveSession(sessionId) {
        let sessions = this._storeController.get('sessions');
        if (!sessions) {
            sessions = [];
        }

        let session = {
            id: sessionId,
            date: new Date()
        };

        let index = -1;
        for (let i = 0; i < sessions.length && index === -1; i++) {
            let aux = sessions[i].id;
            if (aux === sessionId) {
                index = i;
            }
        };

        if (index !== -1) {
            sessions[index] = session;
            sessions.sort((a, b) => {
                return b.date.toString() - a.date.toString();
            });
        } else {
            sessions.push(session);
        }


        if (sessions.length > 10) {
            sessions = sessions.slice(sessions.length - 10, sessions.length);
        }
        this._storeController.set('sessions', sessions);
        //this.listAllSessions();
    }

    listAllSessions(noState) {

        let sessions = this._storeController.get('sessions');
        if (!sessions) {
            sessions = [];
        }
        //console.log(sessions);
        if (noState === true) {
            return sessions;
        } else {
            this.reactComponent.setState({ sessions });
        }
    }

    processPickedFiles(pickedObjects) {
        let mostUsedFiles = this._storeController.get('mostUsedFiles');
        if (!mostUsedFiles) {
            mostUsedFiles = [];
        }
        pickedObjects.forEach((currPicked) => {
            let currentFile = mostUsedFiles.find((element) => {
                return element.file.fileId === currPicked.fileId;
            });
            if (currentFile) {
                currentFile.count = currentFile.count + 1;
            } else {
                mostUsedFiles.push({
                    file: currPicked,
                    count: 1
                });
            }
        });

        //console.log(mostUsedFiles);
        this._storeController.set('mostUsedFiles', mostUsedFiles);
        this.listMostUsedFiles();
    }

    listMostUsedFiles() {
        let mostUsedFiles = this._storeController.get('mostUsedFiles');
        if (!mostUsedFiles) {
            mostUsedFiles = [];
        }
        //console.log(sessions);
        this.reactComponent.setState({ mostUsedFiles });
    }

}

export default HomeController;